export default {

    searchRedPfSvg: function() {

        return `<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n" +
                                               "        <defs>\n" +
                                               " <clipPath id=\"clip-Search_Red\">\n" +
                                              "                <rect width=\"24\" height=\"24\"/>\n" +
                                            "  </clipPath>\n" +
                                            "        </defs>\n" +
                                             " <g id=\"Arrow_Down_Red\" clip-path=\"url(#clip-Search_Red)\">\n" +
                                               " <g id=\"Group_13342\" data-name=\"Group_13342\">
                                                "  <path id=\"Path_60\" data-name=\"Path 60\" d=\"M0,24H24V0H0Z\" stroke=\"rgba(0,0,0,0)\" stroke-width=\"1\" opacity=\"0\"/>\n" +
                                                 " <path id=\"Path_61\" class="svg-primary-color" data-name=\"Path 61\" d=\"M15.5,14h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,4.99L20.49,19Zm-6,0A4.5,4.5,0,1,1,14,9.5,4.494,4.494,0,0,1,9.5,14Z\" transform=\"translate(0 0.59)\" stroke=\"rgba(0,0,0,0)\" stroke-width=\"1\" '/>\n" +
                                                "</g>\n" +
                                              "</g>\n" +
                                            "</svg>`;
    }
};



// WEBPACK FOOTER //
// ./src/common/plugins/svg/SearchRedPfPlugin.js